const homePage = {
  hero: {
    kicker: "Heilbrigðisrannsóknargögn · dulnefning",
    titleLine1: "Rannsakendur fá gögnin.",
    titleLine2: "Enginn fær auðkennin.",
    body: "Heilbrigðisrannsóknargögn berast full af beinum auðkennum — kennitölum, nöfnum, heimilisföngum, símanúmerum. Rannsakendur þurfa gögnin; þeir þurfa ekki auðkennin. Nafnleyndarkerfi stendur þar á milli: hverju auðkenni er skipt út fyrir kóða sem ber engar upplýsingar um manneskjuna, og raunveruleg gildi eru dulkóðuð undir aðskildum lyklum.",
    links: {
      howItWorks: "Hvernig kerfið virkar",
      login: "Skrá inn",
    },
  },
  isolationFigure: {
    sourceRecordLabel: "Upprunaleg færsla",
    directIdentifiers: "Bein auðkenni, geymd dulkóðuð",
    project1Label: "Verkefni — Hjartarannsókn",
    project2Label: "Verkefni — Sykursýkisskrá",
    subjectPrefix: "þátttakandi",
    caption:
      "Sama manneskjan, úr sömu upprunaskránni, í tveimur verkefnum. Innan verkefnis er kóðinn stöðugur, svo hægt er að tengja gagnasöfn saman og samstarfsfólk getur rætt sama þátttakandann. Á milli verkefna passa kóðarnir aldrei saman — verkefnin tvö geta hvorki sameinað gögn sín né komist að því að þau deili þátttakanda.",
  },
  theRule: {
    kicker: "Reglan sem skiptir máli",
    title: "Dulnefni er stöðugt innan verkefnis, en ólíkt í hverju öðru verkefni.",
    body: "Þetta er gert af ásetningi: samvinna innan samþykkts verkefnis, ströng aðgreining milli verkefna. Kóðar hvers verkefnis koma frá sínum eigin dulnefnislykli, sem er varðveittur í sérstakri lyklastýringarþjónustu.",
  },
  steps: {
    kicker: "Frá upphleðslu til greiningar",
    title: "Fjögur skref",
    items: {
      dataArrives: {
        title: "Gögn berast",
        body: "Sjúkrahús, skrá eða rannsakandi hleður upp CSV-skrá inn í verkefni. Ekkert er enn vistað.",
      },
      identifiersFound: {
        title: "Auðkenni eru fundin",
        body: "Kerfið merkir dálka sem innihalda persónuupplýsingar — og les innan í lausum texta, þar sem kennitala falin í setningu er lekinn sem enginn kemur auga á handvirkt.",
      },
      personConfirms: {
        title: "Manneskja staðfestir",
        body: "Sá sem hleður upp fer yfir hverja niðurstöðu og ákveður: skipta út auðkenninu, eða sleppa dálkinum svo að hrátt innihald hans sé aldrei vistað.",
      },
      researchersWork: {
        title: "Rannsakendur vinna með dulnefni",
        body: "Gagnasafnið birtist í yfirliti gagnasafna með kóða í stað auðkenna. Upprunalegu gildin eru dulkóðuð undir aðskildum lyklum.",
      },
    },
  },
  roles: {
    kicker: "Hverjir nota kerfið",
    title: "Fjórar tegundir notendaaðganga",
    body: "Aðgangur fylgir þátttöku í verkefni, ekki starfsaldri. Allir tilheyra nákvæmlega einni deild, og ekkert fer á milli deilda — heilbrigðisvísindi og félagsvísindi deila hugbúnaðinum og engu öðru.",
    items: {
      researchers: {
        title: "Rannsakendur",
        body: "Skoða yfirlit gagnasafna, sækja það sem þeir hafa heimild fyrir, óska eftir því sem þeir hafa ekki, og dulnefna sínar eigin skrár.",
      },
      principalInvestigators: {
        title: "Verkefnisstjórar",
        body: "Stýra verkefnum: bjóða meðlimum, setja aðgangsstefnu, fara yfir gagnabeiðnir, hlaða upp gögnum, og framsenda beiðnir til utanaðkomandi gagnaveitenda.",
      },
      departmentHeads: {
        title: "Deildarstjórar",
        body: "Hafa yfirsýn yfir öll verkefni, gagnasöfn, beiðnir og notendur í sinni deild — en hafa af ásetningi ekki heimild til að sækja rannsóknargögn.",
      },
      dataProviders: {
        title: "Gagnaveitendur",
        body: "Starfsfólk sjúkrahúsa og skráa sem leggur til gögn. Þau sjá eingöngu beiðnir sem er beint til þeirra og upphleðslueyðublaðið — aldrei yfirlit gagnasafna eða niðurstöður neins.",
      },
    },
  },
  limits: {
    kicker: "Umfang",
    title: "Það sem kerfið gerir ekki",
    items: {
      notAnonymization: {
        title: "Þetta er ekki tölfræðileg nafnleysing.",
        body: "Dulnefning ver auðkenni, ekki uppljóstrun í gegnum fámenna hópa. Gagnasafn með þremur sjúklingum með sjaldgæfa greiningu er áfram viðkvæmt, og skyldur þínar gagnvart gögnunum sjálfum hverfa ekki.",
      },
      notEthicsReplacement: {
        title: "Þetta kemur ekki í staðinn fyrir siðanefndarleyfi eða vinnslusamning um gögn.",
        body: "Þetta er tæknileg vörn sem hjálpar þér að uppfylla skyldur þínar samkvæmt siðanefndarleyfi og persónuverndarlöggjöf — ekki staðgengill fyrir hvorugt.",
      },
      notAccessDecision: {
        title: "Þetta ákveður ekki hver má sjá hvað.",
        body: "Það gerir fólk. Verkefnisstjórar og deildarstjórar setja stefnuna; kerfið framfylgir henni, skráir hana og gerir hana yfirferðarhæfa.",
      },
    },
  },
  nextSteps: {
    cards: {
      about: {
        title: "Um kerfið og notkun þess",
        footerLink: "Lesa leiðbeiningarnar →",
        body: "Hlutverk, fyrstu skref, yfirlit gagnasafna, gagnabeiðnir, upphleðsla gagna, og hvað á að gera þegar eitthvað virðist athugavert. Engin tæknikunnátta er forsenda.",
      },
      security: {
        title: "Öryggi",
        footerLink: "Hvernig gögn eru vernduð →",
        body: "Hvernig lyklum er stýrt, hvernig gögn eru dulkóðuð, hvernig aðgangi er stýrt, og hvað er skráð. Fyrir alla sem þurfa að geta treyst kerfinu áður en þeir setja gögn í það.",
      },
      roadmap: {
        title: "Vegvísir",
        footerLink: "Staðan eins og hún er →",
        body: "Það sem er tilbúið og virkar í dag, lýst eins og staðan er í raun en ekki eins og við myndum vilja hafa hana.",
      },
    },
  },
  access: {
    title: "Aðgangur er eingöngu með boði",
    body: "Sjálfskráning er ekki í boði. Verkefnisstjórinn þinn býður þér aðgang með netfangi. Boðið getur enginn annar notað. Tvíþátta auðkenning er skylda fyrir alla notendaaðganga.",
    writeToUsBefore: "Vill deildin þín eða rannsóknareiningin fá sitt eigið svæði í kerfinu? Sendu tölvupóst á",
    writeToUsSubject: "Ný deild í Nafnleyndarkerfi",
    login: "Skrá inn",
  },
};

export default homePage;
